import { LoadingState } from "../../../shared/withLoadableSlice.types";
import {
  ReportsPeriod,
  ReportTypes,
} from "../../../../helpers/reports.helper.types";

export const LOAD_BARCHART = "[REPORTS] LOAD_BARCHART";
export const LOAD_BARCHART_SUCCESS = "[REPORTS] LOAD_BARCHART_SUCCESS";
export const LOAD_BARCHART_FAILURE = "[REPORTS] LOAD_BARCHART_FAILURE";

interface LoadBarChartAction {
  type: typeof LOAD_BARCHART;
  payload: {
    period: ReportsPeriod;
    profile: string;
  };
}

interface LoadBarChartSuccessAction {
  type: typeof LOAD_BARCHART_SUCCESS;
  payload: {
    data: FormattedBarChartStoreSlice[];
    period: ReportsPeriod;
    profile: string;
  };
}

interface LoadBarChartFailureAction {
  type: typeof LOAD_BARCHART_FAILURE;
  payload: {
    error: any;
    period: ReportsPeriod;
    profile: string;
  };
}

export type BarChartActionTypes =
  | LoadBarChartAction
  | LoadBarChartSuccessAction
  | LoadBarChartFailureAction;

export interface FormattedBarChartStoreSlice {
  [ReportTypes.Activity]?: number;
  [ReportTypes.Webfilter]?: number;
  [ReportTypes.Malware]?: number;
  time: number;
}

export interface BarChartState extends LoadingState {
  data: FormattedBarChartStoreSlice[];
  period: ReportsPeriod;
  profile: string;
}
